import { useContext } from 'react';
import { SectionBase } from '../ui/SectionBase';
import { CommonContentContext } from '@/utils/context/commonContent/CommonContentContext';
import { LogoutIcon } from '../icons';
import { useAuth } from '@/utils/hooks/useAuth';

export const MultipleTenants = ({ tenants, setIsSelectedTenant }) => {
  const { setTenantId } = useContext(CommonContentContext);
  const { logout } = useAuth();

  const handleSelectTenant = (tenantId: string) => {
    localStorage.setItem('TENANT_ID', tenantId);
    setTenantId(tenantId);
    setIsSelectedTenant(true);
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4" data-cy="multipleTenant-page">
      <div>
        <img src="/logos/growdata-logo-ops-product-dark-green-onwhite.png" alt="Growdata logo" width={480} />
      </div>
      <SectionBase className="mt-5">
        <div>
          <h2 className="text-lg font-semibold text-gray-700">Select your Tenant</h2>
          <p className="text-sm text-gray-500">Once Selected, you will be redirect to the OPS management dashboard</p>
        </div>
        <div className="mt-4 space-y-2">
          {tenants.map((tenant) => (
            <button
              onClick={(e) => handleSelectTenant(String(tenant.id))}
              key={tenant.id}
              className="tenantBtn w-full rounded-md bg-gray-100 p-3 text-left font-medium text-primary hover:bg-gray-200"
            >
              {tenant.name}
            </button>
          ))}
        </div>
      </SectionBase>
      <button
        onClick={() => logout('redirect')}
        className="mt-6 flex items-center gap-2 rounded-md px-4 py-2 text-gray-600 hover:bg-gray-100 hover:text-primary"
        data-cy="logout-button"
      >
        <LogoutIcon className="h-[20px] w-[20px] fill-current" />
        <span className="text-sm font-medium">Logout</span>
      </button>
    </div>
  );
};
